module.exports = __webpack_public_path__ + "static/media/fitness.889f5720.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/fitness.svg
// module id = 1429
// module chunks = 0